import { render, staticRenderFns } from "./RemindersTable.vue?vue&type=template&id=33cbda15&scoped=true&"
import script from "./RemindersTable.vue?vue&type=script&lang=js&"
export * from "./RemindersTable.vue?vue&type=script&lang=js&"
import style0 from "./RemindersTable.vue?vue&type=style&index=0&id=33cbda15&prod&scoped=true&lang=css&"
import style1 from "./RemindersTable.vue?vue&type=style&index=1&id=33cbda15&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33cbda15",
  null
  
)

export default component.exports